import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dayjsFormatter',
  standalone: true,
})
export class DayjsFormatterPipe implements PipeTransform {
  transform(value: string, template: string = 'MM/DD/YYYY'): string {
    if (!value) {
      return null;
    }

    return dayjs(value).format(template);
  }
}
